/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setModal.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページURL取得
 */
// var getPathName = location.pathname;
// var pageName = /(recruit)/g;

/**
 * モーダル
 */
const setModal = () => {
  const modalBox = document.getElementById("modal");
  const modalTriggers = document.querySelectorAll(".js-modal-trigger");
  const modalTargets = document.querySelectorAll(".js-modal-target");
  const modalCloseBtn = document.querySelectorAll(".close-button");
  var video = document.getElementById('video');

  for (let i = 0; i < modalTriggers.length; i++) {
    modalTriggers[i].addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let currentModal = document.getElementById(currentTarget.dataset.modal);

      /**
       * モーダルオープン
       */
      if (currentModal !== null) {
        currentModal.classList.add("is-active");
        modalBox.classList.add("is-active");
        document.body.style.overflow = "hidden";
      }

      /**
       * モーダルクローズ - 閉じるボタン
       */
      for (let i = 0; i < modalCloseBtn.length; i++) {
        modalCloseBtn[i].addEventListener("click", () => {
          modalTargets[i].classList.remove("is-active");
          modalBox.classList.remove("is-active");
          document.body.style.overflow = "";
          video.pause();
        });
      }

      /**
       * モーダルクローズ - モーダル背景
       */
      // for (let i = 0; i < modalTargets.length; i++) {
      //   modalBox.addEventListener("click", () => {
      //     modalTargets[i].classList.remove("is-active");
      //     modalBox.classList.remove("is-active");
      //     document.body.style.overflow = "";
      //   });
      // }
    });
  }
};

export { setModal };
